export const home = {
  heroTitle: "Vende tus cosas en",
  heroTitleAccent: "segundos",
  heroSubtitle: "Haz una foto: recibes el texto del anuncio y una sugerencia de precio.",
  draftSaved: "Tienes un borrador guardado.",
  draftContinue: "Continúa donde lo dejaste",
  sheetTitle: "¿Qué quieres vender?",
  sheetDescription: "Elige cómo quieres empezar.",
  ctaTitle: "Fotografía tu artículo: nosotros escribimos el anuncio",
  ctaSubtitle: "Haz una foto: obtienes el texto y una sugerencia de precio, y publicas gratis.",
  ctaButton: "Empezar",
  latestTitle: "Últimos anuncios",
  latestSubtitle: "De todo el país.",
  seeAll: "Ver todos los anuncios",
  empty: "Aún no hay anuncios: sé el primero en publicar uno.",
} as const;
